<template>
  <div>
    <ContentPage headerText="Our Services">
      <p>
        Regular chimney sweeping is essential for preventing dangerous build up of soot that can cause chimney fires. 
        I use professional-grade tools to clean your chimney thoroughly and ensure proper airflow, 
        improving the efficiency of your heating system.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
          <div
            v-for="(service, index) in services"
            :key="service.name"
            class="section"
            :class="{ 'first-section': index === 0 }"
          >
            <div>
              <h2>{{ service.name }}</h2>

              <p>{{ service.description }}</p>
            </div>

            <div class="image-card">
              <img
                class="image-card-img"
                :src="service.imgSrc"
                :alt="service.imgAltText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/lib/services'
import ContentPage from '../partials/ContentPage.vue'

export default {
  name: 'areas-we-cover',
  components: {
    ContentPage
  },
  data () {
    return {
      services
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: $clr-theme-light-gray;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}

.section {
  $gutter: 2rem;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  gap: $gutter;

  h2 {
    font-size: 2rem;
    margin-bottom: $gutter;
  }

  img {
    height: auto;
  }

  img:first-of-type {
    max-height: 363.33px;
    object-fit: fill;
    @media (min-width: $sm-breakpoint) {
      max-height: none;
      height: 353.33px;
      width: 529.98px;
      object-fit: cover;
    }
    @media (min-width: $sm-md-breakpoint) {
      height: 473.33px;
      width: 709.98px;
    }
    @media (min-width: $md-breakpoint) {
      height: 400px;
      width: 100%;
    }
  }

  @media (min-width: $md-breakpoint) {
    gap: 4rem;
    flex-direction: row;

    > * {
      flex: 1;
    }

    &:nth-child(2n) {
      div:first-of-type {
        order: 2;
      }

      .image-card {
        order: 1;
      }
    }
  }
}




.list {
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 30px;
  column-gap: 20px;

  li {
    width: 100%;

    @media (min-width: $xs-breakpoint) {
      width: 50%;
    }

    @media (min-width: $sm-md-breakpoint) {
      width: 33.33%;
    }

    @media (min-width: $md-breakpoint) {
      width: calc(33.33% - 20px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Services.vue